import { Box, Divider, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

interface BillableToDateTooltipMessageProps {
  currency: string
  hoursPerBillRate: number
  spendingCostsApprovedAmountCents: number
  noBudget?: boolean
}

const BillableToDateTooltipMessage = ({
  currency,
  hoursPerBillRate,
  spendingCostsApprovedAmountCents,
  noBudget,
}: BillableToDateTooltipMessageProps) => {
  const {
    access: { locale },
  } = useCurrentSession()

  return (
    <>
      <Box alignItems="flexStart">
        <Text size="200" color="grey000White" weight="semibold">
          {noBudget
            ? i18n
                .t(
                  'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.billable_to_date'
                )
                .toUpperCase()
            : i18n
                .t(
                  'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.used_budget'
                )
                .toUpperCase()}
        </Text>
      </Box>

      <Box flexDirection="row" justifyContent="spaceBetween" paddingY="s16">
        <Text size="300" color="grey000White" weight="medium">
          {i18n.t(
            'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.hours_bill_rate'
          )}
        </Text>
        <Text size="300" color="grey000White" weight="medium">
          {MoneyWithCurrency({ amount: Math.round(hoursPerBillRate), currency, locale })}
        </Text>
      </Box>
      <Divider backgroundColor="#FFFFFF" />
      <Box paddingTop="s16" gap="s4">
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text size="300" color="grey000White" weight="medium">
            {i18n.t(
              'project_management.overview.sections.financial_details.insights.revenue_to_date.tooltip_message.billable_spendings'
            )}
          </Text>
          <Text size="300" color="grey000White" weight="medium">
            {MoneyWithCurrency({ amount: spendingCostsApprovedAmountCents, currency, locale })}
          </Text>
        </Box>
      </Box>
    </>
  )
}

export default BillableToDateTooltipMessage
